export const ENSURE_SITTING_LOADED_SIGNAL =
  'edrolo/exams/ENSURE_SITTING_LOADED_SIGNAL';

export const LOAD_EXAM_SIGNAL = 'edrolo/exams/LOAD_EXAM_SIGNAL';
export const LOAD_EXAM_REQUEST = 'edrolo/exams/LOAD_EXAM_REQUEST';
export const LOAD_EXAM_SUCCESS = 'edrolo/exams/LOAD_EXAM_SUCCESS';
export const LOAD_EXAM_FAILURE = 'edrolo/exams/LOAD_EXAM_FAILURE';

export const LOAD_EXAM_SOLUTION_SIGNAL =
  'edrolo/exams/LOAD_EXAM_SOLUTION_SIGNAL';
export const LOAD_EXAM_SOLUTION_REQUEST =
  'edrolo/exams/LOAD_EXAM_SOLUTION_REQUEST';
export const LOAD_EXAM_SOLUTION_SUCCESS =
  'edrolo/exams/LOAD_EXAM_SOLUTION_SUCCESS';
export const LOAD_EXAM_SOLUTION_FAILURE =
  'edrolo/exams/LOAD_EXAM_SOLUTION_FAILURE';

export const LOAD_CLASS_QUESTION_RESPONSES_SIGNAL =
  'edrolo/exams/LOAD_CLASS_QUESTION_RESPONSES_SIGNAL';
export const LOAD_CLASS_QUESTION_RESPONSES_REQUEST =
  'edrolo/exams/LOAD_CLASS_QUESTION_RESPONSES_REQUEST';
export const LOAD_CLASS_QUESTION_RESPONSES_SUCCESS =
  'edrolo/exams/LOAD_CLASS_QUESTION_RESPONSES_SUCCESS';
export const LOAD_CLASS_QUESTION_RESPONSES_FAILURE =
  'edrolo/exams/LOAD_CLASS_QUESTION_RESPONSES_FAILURE';

export const CREATE_SITTING_REQUEST = 'edrolo/exams/CREATE_SITTING_REQUEST';
export const CREATE_SITTING_SUCCESS = 'edrolo/exams/CREATE_SITTING_SUCCESS';
export const CREATE_SITTING_FAILURE = 'edrolo/exams/CREATE_SITTING_FAILURE';

export const LOAD_SITTING_REQUEST = 'edrolo/exams/LOAD_SITTING_REQUEST';
export const LOAD_SITTING_SUCCESS = 'edrolo/exams/LOAD_SITTING_SUCCESS';
export const LOAD_SITTING_FAILURE = 'edrolo/exams/LOAD_SITTING_FAILURE';

export const SUBMIT_QUESTION_RESPONSE_SIGNAL =
  'edrolo/exams/SUBMIT_QUESTION_RESPONSE_SIGNAL';
export const SUBMIT_QUESTION_RESPONSE_REQUEST =
  'edrolo/exams/SUBMIT_QUESTION_RESPONSE_REQUEST';
export const SUBMIT_QUESTION_RESPONSE_SUCCESS =
  'edrolo/exams/SUBMIT_QUESTION_RESPONSE_SUCCESS';
export const SUBMIT_QUESTION_RESPONSE_FAILURE =
  'edrolo/exams/SUBMIT_QUESTION_RESPONSE_FAILURE';

export const SUBMIT_QUESTION_GROK_SIGNAL =
  'edrolo/exams/SUBMIT_QUESTION_GROK_SIGNAL';
export const SUBMIT_QUESTION_GROK_REQUEST =
  'edrolo/exams/SUBMIT_QUESTION_GROK_REQUEST';
export const SUBMIT_QUESTION_GROK_SUCCESS =
  'edrolo/exams/SUBMIT_QUESTION_GROK_SUCCESS';
export const SUBMIT_QUESTION_GROK_FAILURE =
  'edrolo/exams/SUBMIT_QUESTION_GROK_FAILURE';

export const SUBMIT_QUESTION_MARK_SIGNAL =
  'edrolo/exams/SUBMIT_QUESTION_MARK_SIGNAL';
export const SUBMIT_QUESTION_MARK_REQUEST =
  'edrolo/exams/SUBMIT_QUESTION_MARK_REQUEST';
export const SUBMIT_QUESTION_MARK_SUCCESS =
  'edrolo/exams/SUBMIT_QUESTION_MARK_SUCCESS';
export const SUBMIT_QUESTION_MARK_FAILURE =
  'edrolo/exams/SUBMIT_QUESTION_MARK_FAILURE';

export const SUBMIT_CHECKLIST_REFLECTION_SIGNAL =
  'edrolo/exams/SUBMIT_CHECKLIST_REFLECTION_SIGNAL';
export const SUBMIT_CHECKLIST_REFLECTION_REQUEST =
  'edrolo/exams/SUBMIT_CHECKLIST_REFLECTION_REQUEST';
export const SUBMIT_CHECKLIST_REFLECTION_SUCCESS =
  'edrolo/exams/SUBMIT_CHECKLIST_REFLECTION_SUCCESS';
export const SUBMIT_CHECKLIST_REFLECTION_FAILURE =
  'edrolo/exams/SUBMIT_CHECKLIST_REFLECTION_FAILURE';

export const FETCH_CLASS_LESSON_QUESTION_AGGREGATES_SIGNAL =
  'edrolo/exams/FETCH_CLASS_LESSON_QUESTION_AGGREGATES_SIGNAL';
export const FETCH_CLASS_LESSON_QUESTION_AGGREGATES_REQUEST =
  'edrolo/exams/FETCH_CLASS_LESSON_QUESTION_AGGREGATES_REQUEST';
export const FETCH_CLASS_LESSON_QUESTION_AGGREGATES_SUCCESS =
  'edrolo/exams/FETCH_CLASS_LESSON_QUESTION_AGGREGATES_SUCCESS';
export const FETCH_CLASS_LESSON_QUESTION_AGGREGATES_FAILURE =
  'edrolo/exams/FETCH_CLASS_LESSON_QUESTION_AGGREGATES_FAILURE';

export const LOAD_CLASS_EXAM_SITTINGS_SIGNAL =
  'edrolo/exams/LOAD_CLASS_EXAM_SITTINGS_SIGNAL';
export const LOAD_CLASS_EXAM_SITTINGS_REQUEST =
  'edrolo/exams/LOAD_CLASS_EXAM_SITTINGS_REQUEST';
export const LOAD_CLASS_EXAM_SITTINGS_SUCCESS =
  'edrolo/exams/LOAD_CLASS_EXAM_SITTINGS_SUCCESS';
export const LOAD_CLASS_EXAM_SITTINGS_FAILURE =
  'edrolo/exams/LOAD_CLASS_EXAM_SITTINGS_FAILURE';

// load exam takes care of loading an exam data
export const loadExam = {
  signal: (examId, isDemo) => ({
    type: LOAD_EXAM_SIGNAL,
    payload: { examId, isDemo },
  }),
  request: (examId) => ({
    type: LOAD_EXAM_REQUEST,
    payload: { examId },
  }),
  success: (examId, examData) => ({
    type: LOAD_EXAM_SUCCESS,
    payload: { examId, examData },
  }),
  failure: (examId, status, failureReason) => ({
    type: LOAD_EXAM_FAILURE,
    payload: { examId, status, failureReason },
  }),
};

export const loadExamSolution = {
  signal: (examId) => ({
    type: LOAD_EXAM_SOLUTION_SIGNAL,
    payload: { examId },
  }),
  request: (examId) => ({
    type: LOAD_EXAM_SOLUTION_REQUEST,
    payload: { examId },
  }),
  success: (solutionData) => ({
    type: LOAD_EXAM_SOLUTION_SUCCESS,
    payload: { solutionData },
  }),
  failure: (errors) => ({
    type: LOAD_EXAM_SOLUTION_FAILURE,
    payload: { errors },
  }),
};

export const loadClassQuestionResponses = {
  signal: (classId, examId, questionId) => ({
    type: LOAD_CLASS_QUESTION_RESPONSES_SIGNAL,
    payload: { classId, examId, questionId },
  }),
  request: (classId, examId, questionId) => ({
    type: LOAD_CLASS_QUESTION_RESPONSES_REQUEST,
    payload: { classId, examId, questionId },
  }),
  success: (classId, examId, questionId, responses) => ({
    type: LOAD_CLASS_QUESTION_RESPONSES_SUCCESS,
    payload: { classId, examId, questionId, responses },
  }),
  failure: (errors) => ({
    type: LOAD_CLASS_QUESTION_RESPONSES_FAILURE,
    payload: { errors },
  }),
};

export const loadSitting = {
  request: (examId) => ({
    type: LOAD_SITTING_REQUEST,
    payload: { examId },
  }),
  success: (sittingData) => ({
    type: LOAD_SITTING_SUCCESS,
    payload: { sittingData },
  }),
  failure: (errors) => ({
    type: LOAD_SITTING_FAILURE,
    payload: { errors },
  }),
};

export const createSitting = {
  request: (examId) => ({
    type: CREATE_SITTING_REQUEST,
    payload: { examId },
  }),
  success: (sittingData) => ({
    type: CREATE_SITTING_SUCCESS,
    payload: { sittingData },
  }),
  failure: (errors) => ({
    type: CREATE_SITTING_FAILURE,
    payload: { errors },
  }),
};

export const ensureSittingLoaded = {
  signal: (examId) => ({
    type: ENSURE_SITTING_LOADED_SIGNAL,
    payload: { examId },
  }),
};

// loads exam completion aggregates, etc
export const fetchClassQuestionSetAggregates = {
  signal: (examId, classId) => ({
    type: FETCH_CLASS_LESSON_QUESTION_AGGREGATES_SIGNAL,
    payload: { examId, classId },
  }),
  request: (examId, classId) => ({
    type: FETCH_CLASS_LESSON_QUESTION_AGGREGATES_REQUEST,
    payload: { examId, classId },
  }),
  success: (examId, classId, aggregateData) => ({
    type: FETCH_CLASS_LESSON_QUESTION_AGGREGATES_SUCCESS,
    payload: { examId, classId, aggregateData },
  }),
  failure: (examId, classId, errors) => ({
    type: FETCH_CLASS_LESSON_QUESTION_AGGREGATES_FAILURE,
    payload: { examId, classId, errors },
  }),
};

export const loadClassExamSittings = {
  signal: (classId, examId) => ({
    type: LOAD_CLASS_EXAM_SITTINGS_SIGNAL,
    payload: { classId, examId },
  }),
  request: (classId, examId) => ({
    type: LOAD_CLASS_EXAM_SITTINGS_REQUEST,
    payload: { classId, examId },
  }),
  success: (classId, examId, sittings) => ({
    type: LOAD_CLASS_EXAM_SITTINGS_SUCCESS,
    payload: {
      classId,
      examId,
      sittings,
    },
  }),
  failure: (errors) => ({
    type: LOAD_CLASS_EXAM_SITTINGS_FAILURE,
    payload: { errors },
  }),
};

// signal triggers saga
export const submitQuestionResponse = {
  signal: (examId, questionId, sittingId, typeSpecificData) => ({
    type: SUBMIT_QUESTION_RESPONSE_SIGNAL,
    payload: {
      examId,
      questionId,
      sittingId,
      typeSpecificData,
    },
  }),
  request: (examId, questionId, sittingId, typeSpecificData) => ({
    type: SUBMIT_QUESTION_RESPONSE_REQUEST,
    payload: {
      examId,
      questionId,
      sittingId,
      typeSpecificData,
    },
  }),
  success: (examId, questionId, responseData) => ({
    type: SUBMIT_QUESTION_RESPONSE_SUCCESS,
    payload: { examId, questionId, responseData },
  }),
  failure: (examId, questionId, errors) => ({
    type: SUBMIT_QUESTION_RESPONSE_FAILURE,
    payload: { examId, questionId, errors },
  }),
};

export const submitChecklistReflectionItem = {
  signal: (questionId, sittingId, checklistReflectionItem) => ({
    type: SUBMIT_CHECKLIST_REFLECTION_SIGNAL,
    payload: {
      questionId,
      sittingId,
      checklistReflectionItem,
    },
  }),
  request: (questionId, sittingId, checklistReflectionItem) => ({
    type: SUBMIT_CHECKLIST_REFLECTION_REQUEST,
    payload: { questionId, sittingId, checklistReflectionItem },
  }),
  success: (questionId, responseData) => ({
    type: SUBMIT_CHECKLIST_REFLECTION_SUCCESS,
    payload: { questionId, responseData },
  }),
  failure: (errors) => ({
    type: SUBMIT_CHECKLIST_REFLECTION_FAILURE,
    payload: { errors },
  }),
};

export const submitQuestionGrok = {
  signal: (examId, questionId, sittingId, grokked) => ({
    type: SUBMIT_QUESTION_GROK_SIGNAL,
    payload: {
      examId,
      questionId,
      sittingId,
      grokked,
    }, // examId and nextQuestion used for redirect
  }),
  request: (examId, questionId, sittingId, grokked) => ({
    type: SUBMIT_QUESTION_GROK_REQUEST,
    payload: { examId, questionId, sittingId, grokked },
  }),
  success: (examId, questionId, responseData) => ({
    type: SUBMIT_QUESTION_GROK_SUCCESS,
    payload: { examId, questionId, responseData },
  }),
  failure: (questionId, currentGrokValue, errors) => ({
    type: SUBMIT_QUESTION_GROK_FAILURE,
    payload: { questionId, currentGrokValue, errors },
  }),
};

export const submitQuestionMark = {
  signal: (questionId, sittingId, mark) => ({
    type: SUBMIT_QUESTION_MARK_SIGNAL,
    payload: {
      questionId,
      sittingId,
      mark,
    },
  }),
  request: (questionId, sittingId, mark) => ({
    type: SUBMIT_QUESTION_MARK_REQUEST,
    payload: { questionId, sittingId, mark },
  }),
  success: (questionId, responseData) => ({
    type: SUBMIT_QUESTION_MARK_SUCCESS,
    payload: { questionId, responseData },
  }),
  failure: (questionId, currentMarkValue, errors) => ({
    type: SUBMIT_QUESTION_MARK_FAILURE,
    payload: { questionId, currentMarkValue, errors },
  }),
};
